import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import save from './save';
import './style.scss';
import './editor.scss';

registerBlockType( metadata.name, {
	edit: Edit,
	save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
				fill="currentColor"
			>
				{ /* Top-left finder pattern */ }
				<path d="M3 3h7v7H3V3zm2 2v3h3V5H5z" />
				{ /* Top-right finder pattern */ }
				<path d="M14 3h7v7h-7V3zm2 2v3h3V5h-3z" />
				{ /* Bottom-left finder pattern */ }
				<path d="M3 14h7v7H3v-7zm2 2v3h3v-3H5z" />
				{ /* Data modules (bottom-right) */ }
				<rect x="14" y="14" width="3" height="3" />
				<rect x="18" y="14" width="3" height="3" />
				<rect x="14" y="18" width="3" height="3" />
				<rect x="18" y="18" width="3" height="3" />
			</svg>
		),
	},
} );
